import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useState } from "preact/hooks";
import { productImagePlaceholder, formatCurrency } from "../helpers"

export default function Product({ product }) {
    const tags = [
        product.onSale
            ? {
                label: "Sale",
                class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
            }
            : undefined
    ].filter(v => !!v)

    const productDiscount = Math.round(((product.listPrice - product.price) / product.listPrice) * 100);

    const skuAvailability = {};

    product?.skus?.forEach(sku => {
        skuAvailability[sku.id] = sku.availability;
    });

    let sizes = [];
    let colors = [];
    product?.skus?.forEach(sku => {
        sku.customFields.forEach(customField => {
            if (customField.key === 'size') {
                sizes.push({ value: customField.value, availability: skuAvailability[sku.id] });
            } else if (customField.key === 'color' || customField.key === 'colour') {
                colors.push(customField.value);
            }
        });
    });

    const distinctColorSizeValues = (value, index, self) => {
        return self?.indexOf(value) === index;
    }

    let distinctSizes = sizes.filter(distinctColorSizeValues);
    let distinctColors = colors.filter(distinctColorSizeValues);

    function findCustomFieldValueByKeyValue(customFields, key) {
        for (const field of customFields) {
            if (field.key === key) {
                return field.value;
            }
        }
        return null;
    }


    const genderGreyBadge = findCustomFieldValueByKeyValue(product.customFields, 'custom_fields-product_tag');
    const productTypeBadge = findCustomFieldValueByKeyValue(product.customFields, 'producttype');

    const isDefaultTitleOutOfStock = product?.skus?.some(sku =>
        sku?.customFields?.some(field =>
            field.name === "Default Title" && sku.availability !== "InStock" && sku.length < 2
        )
    );

    return (
        <SerpElement
            as="div"
            hit={product}
            x-nosto-handle={product.url.substring(product.url.lastIndexOf('/') + 1)}
            class="ns-product-wrapper nosto-product-info"
            data-id={product.productId}
        >
            <div class="ns-product-badge-wrapper">
                {product?.tags1?.indexOf('new-in') > -1 ? 
                <span class="ns-priority-badge">new in</span>
                :
                product?.tags1?.indexOf('coming soon') > -1 ? 
                <span class="ns-priority-badge">coming soon</span>
                :
                product.listPrice > product.price ? 
                <div class="ns-product-discount-badge">Save {productDiscount}%</div>
                :
                null}
            </div>
            <div class="ns-product-inner">
                <a href={product.url} class="ns-image-wrapper">
                    <img
                        class="ns-primary-image"
                        src={`${product.imageUrl}&width=400`}
                        alt={product.name}
                        loading="lazy"
                    />

                    <img
                        class="ns-secondary-image"
                        src={(product.alternateImageUrls && product.alternateImageUrls.length > 0)
                            ? `${product.alternateImageUrls[0]}&width=400`
                            : `${product.imageUrl}&width=400`}
                        alt={product.name}
                        loading="lazy"
                    />
                </a>
                <div class="ns-below-image">
                    <div class="ns-additional-product-info-badges">
                        {genderGreyBadge && (<span class="ns-additional-info-badge">{genderGreyBadge}</span>)}
                        {productTypeBadge && (<span class="ns-additional-info-badge">{productTypeBadge}</span>)}
                    </div>
                    <div class="ns-product-info-wrapper" data-nosto-element="product">
                        <a href={product.url} class="ns-product-name x-nosto-title">{product.name}</a>
                        <div class="ns-product-price-wrapper">
                            <span class={`nosto-newprice ${product.listPrice > product.price ? "ns-product-discount-price" : "ns-product-regular-price"}`}>
                                {formatCurrency(product.price)}
                            </span>
                            {product.listPrice && product.listPrice > product.price && (
                                <span class="ns-discounted-price nosto-oldprice ns-text-striked">
                                    {formatCurrency(product.listPrice)}
                                </span>
                            )}
                            <div class="yotpo bottomLine yotpo-small ns-yotpo-element" data-product-id={product.productId}> </div>

                        </div>
                    </div>
                    {product.description &&
                        <div class="ns-product-description">{product.description}</div>
                    }
                    <div class="ns-product-size-color-wrap">
                        <p>Available sizes</p>
                        <div class="ns-sizes-wrap">
                            <div class="ns-sizes-wrap">
                                {distinctSizes.length > 0 ?
                                    [...new Set(distinctSizes?.map(sizeObject => sizeObject.value))]?.map((size, index) => (
                                        <div key={index} class={distinctSizes.find(obj => obj.value === size).availability === "InStock" ? "ns-sku-size" : "ns-sku-size ns-text-striked"}>
                                            {size}
                                        </div>
                                    ))
                                    :
                                    // <div class="ns-sku-size">ONE SIZE</div>
                                    <div class={isDefaultTitleOutOfStock ? "ns-sku-size ns-text-striked" : "ns-sku-size"}>
                                        ONE SIZE
                                    </div>
                                }
                            </div>
                        </div>

                        {distinctColors.length > 0 && (<div class="ns-colors-wrap">
                            {distinctColors?.map((color) => (
                                <a href={`${product.url}?variant=${product.skus.length > 1 && product.skus?.find(sku => sku?.customFields?.find(field => field.key.toLowerCase() === 'color' || field.key.toLowerCase() === 'colour').value === color && sku?.availability === "InStock")?.id}`}
                                    // class="ns-sku-color"
                                    class={
                                        product.skus?.some(sku => sku?.customFields?.find(field =>
                                            field.key.toLowerCase() === 'color' || field.key.toLowerCase() === 'colour'
                                        )?.value === color && sku?.availability === "InStock" && sku?.id)
                                            ? "ns-sku-color"
                                            : "ns-sku-color ns-sku-color-unavailable"
                                    }

                                    style={{
                                        backgroundColor: `var(--color-swatch-${color
                                            .replace(/\//g, '-')
                                            .replace(/\s+/g, '-')
                                            .replace(/-+/g, '-')
                                            .toLowerCase()
                                            .replace(/-+$/, '')
                                            })`
                                    }}
                                    data-color={color.replace(/\//g, '-').replace(/---/g, '-').replace(/\s+/g, '-').toLowerCase()}
                                >
                                </a>
                            ))}
                        </div>)}
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}